module.exports = __webpack_public_path__ + "img/logo_gs.c62a1eee.png";